//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular
        .module('container.util')
        .factory('userService', userService);


    function userService(UserResource, $q) {

        var service = {};

        service.getAssignedUserGroups = function () {
            var d = $q.defer();

            UserResource.getAssignedUserGroups({}, {}, function (response) {

                    d.resolve(response);

                }, function (error) {

                    d.reject(error);
                });
            return d.promise;
        };

        return service;

    }


})();